import React from "react";
import PropTypes from "prop-types";
import './index.css';

const Button = ({
  onClick = () => {},
  className = '',
  buttonText = '',
  children = null,
}) => (
  <button className="button-container" onClick={onClick}>
      <span className={`icon ${className}`} />
      <span>{buttonText}</span>
    {children}
  </button>
);

Button.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  supportedTypes: PropTypes.array,
  children: PropTypes.node,
};

export default Button;
